import { ButtonLogin } from "@/shared/components/atoms/ButtonLogin";
import { ImageLogoLogin } from "@/shared/components/atoms/ImageLogoLogin";
import { InputCheck } from "@/shared/components/atoms/InputCheck";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";

import { t } from "i18next";
import { FC, Fragment } from "react";
import { Form } from "react-router-dom";

const RegisterPages: FC<any> = () => {
  return (
    <Fragment>
      <div className="flex flex-col md:flex-row min-h-full flex-1">
        <div className="flex md:flex-1 items-center flex-col md:justify-center px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 pt-3 sm:pt-0">
          <div className="mx-auto  w-full max-w-sm lg:w-96">
            <div>
              <ImageLogoLogin
                src={"https://dash.fitmewise.com/uploads/branchs/default.png"}
                company=""
              />
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                {t("user.views.welcome")}
              </h2>

              <p className="mt-2 text-sm leading-6 text-gray-500">
                {t("user.views.create_profile_description")}
              </p>
            </div>

            <div className="mt-10">
              <div>
                <Form onSubmit={() => {}} className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <InputWithCornerHint
                      label={t("user.views.name_last")}
                      type="text"
                      placeholder={t("user.views.name_last")}
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <InputWithCornerHint
                      label={t("user.views.email")}
                      type="email"
                      placeholder="usuario@mail.com"
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <InputWithCornerHint
                      label={t("user.views.password")}
                      type="password"
                      placeholder={t("user.views.password")}
                    />
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <InputCheck id="log-in-form-terms-input" name="terms" />
                      <a
                        href="https://fitmewise.com/terminos-y-condiciones-de-uso/"
                        className="ml-3 block text-sm leading-6 text-gray-700 hover:text-primary-600 cursor-pointer"
                      >
                        <label htmlFor={""} className="cursor-pointer">
                          {t("user.views.accept_term")}
                        </label>
                      </a>
                    </div>
                  </div>

                  <div>
                    <ButtonLogin texto={t("user.views.send")} />
                  </div>
                </Form>
              </div>
              <div className="mt-10"></div>
            </div>
          </div>
        </div>
        <div className="relative flex-1 lg:block mx-5 mb-10 md:mb-0">
          <iframe
            src="https://www.youtube.com/embed/K2Cdd3XB9vY?si=9TYflzomAzCebLu8"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute inset-0 h-full w-full"
          ></iframe>
        </div>
      </div>
    </Fragment>
  );
};

export default RegisterPages;
